import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  Typography
} from "@mui/material";
import { CircleX } from "lucide-react";
import { useState } from "react";
import { useToastStore } from "../../../stores";
import { colorPrimary } from "../../../theme";
import { formatCurrencyBRL } from "../../../utils/mask/MaskUtils";
import { ProposalCombo } from "../dto/ShopkeeperDTO";
import { submitOfferAnuncio } from "../repository/ShopkeeperRepository";



interface ModalCompreAgoraProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (message: string) => Promise<void>;
  val_minimoProposta: number;
  val_compre_agora: number;
  data_inicio: string;
  tipo_anuncio: string;
  combo_id?: number;
}

export function CompreAgoraModal({
  open,
  onClose,
  onSuccess,
  val_minimoProposta,
  val_compre_agora,
  tipo_anuncio,
  combo_id,
}: ModalCompreAgoraProps) {
  const { setToast } = useToastStore();
  const [isLoading, setLoading] = useState(false);


const handleSubmitProposal = async () => {
  setLoading(true);

  try {

    if (tipo_anuncio === "L" || tipo_anuncio === "C") {
      setToast({ message:"Anúncio não disponível para compra agora.", variant: 'error' });
      return;
    }
    const payload : ProposalCombo ={
      num_id_anuncio: combo_id ?? 0,
      val_proposta: val_compre_agora,
      tag_compra_ou_proposta: "1",
      tag_origem: "0",
    };
  const result = await submitOfferAnuncio(payload);
    if (result.success) {
      setToast({ message:"Compra realizada com sucesso!", variant: 'success' });
      if (onSuccess) await onSuccess("Compra realizada com sucesso!");
      onClose();
    } else {
      setToast({ message:result.message || "Erro ao tentar comprar o veículo.", variant: 'error' });
    }
  } catch (error) {
    setToast({ message: "Erro ao tentar comprar o veículo.", variant: 'error' });
  } finally {
    setLoading(false); // GARANTIDO
  }
};


return (
  <>
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: 420,
            bgcolor: "white",
            borderRadius: 2,
            boxShadow: 24,
            outline: "none",
          }}
        >
        <Box sx={{height: 8,bgcolor: colorPrimary,borderTopLeftRadius: 8,borderTopRightRadius: 8, }}/>
          {/* HEADER */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
            }}
          >
            <Typography
              id="confirmation-modal-title"
              fontSize="1.4rem"
              fontWeight={700}
            >
              Confirmação!
            </Typography>

            <Box
              onClick={onClose}
              sx={{
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 1,
                cursor: "pointer",
                color: colorPrimary,
                transition: "all 0.25s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 80, 80, 0.15)",
                  boxShadow: "0 0 12px rgba(255, 80, 80, 0.45)",
                  transform: "rotate(90deg) scale(1.05)",
                },
              }}
            >
              <CircleX size={28} />
            </Box>
          </Box>

          {/* CONTENT */}
          <Box
            id="confirmation-modal-description"
            sx={{px: 4,py: 4,}} >
            <Typography fontWeight={400} fontSize="1rem">
            Deseja efetuar a compra por{" "}
            <Box
                component="span"
                fontWeight={600}
                color={colorPrimary}
            >
                {formatCurrencyBRL(val_compre_agora ?? 0)}
            </Box>
            </Typography>
          </Box>

          {/* ACTIONS */}
          <Box
            sx={{
              px: 4,
              py: 3,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              variant="text"
              onClick={onClose}
              sx={{
                width: 150,
                color: colorPrimary,
                borderRadius: 2.5,
              }}
            >
              Cancelar
            </Button>

            <Button
              disabled={isLoading}
              onClick={async () => handleSubmitProposal()}
              sx={{
                width: 200,
                background: colorPrimary,
                boxShadow: "0 0 20px rgba(245,159,10,0.35)",
                transition: "0.25s ease",
                borderRadius: 2.5,
                "&:hover": {
                  background: colorPrimary,
                  boxShadow: "0 0 25px rgba(245,159,10,0.55)",
                  transform: "translateY(-1px)",
                },
                color: "#fff",
                fontWeight: 600,
              }}
            >
              {isLoading ?<CircularProgress size={26} sx={{ color: "#fff" }} /> : "Confirmar"}
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  </>
);
}
